// apps/client/src/net/handlers/items.ts — outdoor ground and yard items; room items are M1-T16's decor handler
import type { NetHandlers } from '../../game/game';
import { createItemsLayer, itemsLayerOf, registerItemsLayer } from '../../world/items';
import type { Game } from '../../game/game';

function layerFor(game: Game) {
  let layer = itemsLayerOf(game);
  if (!layer && game.scenes.out) {
    layer = createItemsLayer(game.scenes.out.layer('items'), { assets: game.assets, heightAt: (p) => game.scenes.out!.heightAt(p) });
    registerItemsLayer(game, layer);
  }
  return layer;
}
export const handlers: NetHandlers = {
  onSpace(space, game) { if (space.kind === 'out') void layerFor(game)?.sync(space.items); },
  events: {
    'item.added': (e, game) => { if (e.item.at.loc === 'outdoors') void layerFor(game)?.add(e.item); },
    'item.updated': (e, game) => { if (e.item.at.loc === 'outdoors') void layerFor(game)?.update(e.item); },
    'item.removed': (e, game) => { itemsLayerOf(game)?.remove(e.item); },
  },
};
